import React from "react";
import Notification from "./Notification";
import "./Notification.css";

const NotificationContainer = ({ notifications }) => {
  return (
    <div className="notification-container">
      {notifications.map((n) => (
        <Notification
          key={n.id}
          title={n.title}
          description={n.description}
          status={n.status}
        />
      ))}
    </div>
  );
};

export default NotificationContainer;
